/** Count how many lightbox slides a gallery block contributes (visual order). */
export function countSlidesInGalleryItem(item) {
  if (item.type === 'beforeAfter') return 2;
  if (item.type === 'workPair' && Array.isArray(item.photos)) return item.photos.length;
  if (item.src) return 1;
  return 0;
}

/** Flat list for the lightbox carousel (same order as the grid). */
export function buildGallerySlides(items) {
  const slides = [];
  for (const item of items) {
    if (item.type === 'beforeAfter') {
      slides.push({ src: item.before, alt: item.beforeAlt });
      slides.push({ src: item.after, alt: item.afterAlt });
    } else if (item.type === 'workPair' && Array.isArray(item.photos)) {
      for (const p of item.photos) {
        slides.push({ src: p.src, alt: p.alt });
      }
    } else if (item.src) {
      slides.push({ src: item.src, alt: item.alt });
    }
  }
  return slides;
}
